export default "__VITE_ASSET__F_xpqvQH__"